import React, { useEffect, useState } from "react";
import axios from "../axiosInstance";
import HCaptcha from '@hcaptcha/react-hcaptcha';

const Claim = () => {
  const [slug, setSlug] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [hcaptchaToken, setHcaptchaToken] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const openAd = () => {
    window.open("https://omg10.com/4/9672346", "_blank");
  };

  const handleClaim = async () => {
    setError("");
    setResult(null);

    if (!slug.trim()) {
      return setError("Please enter your banner slug.");
    }

    openAd();
    setLoading(true);

    try {
      const res = await axios.post("/api/claim-reward", {
        slug,
        recaptchaToken: hcaptchaToken,
      });

      setResult(res.data.reward);
    } catch (err) {
      if (err.response?.status === 404) {
        window.location.href = "/submit";
      } else {
        setError(err.response?.data?.error || "Server error");
      }
    }

    setLoading(false);
  };

   // === NOUVEAU AADS ADAPTATIF (mobile + desktop) ===
useEffect(() => {
  const div = document.createElement("div");
  div.innerHTML = `
    <!-- BEGIN AADS AD UNIT 2425494 -->
    
    <!-- END AADS AD UNIT 2425494 -->
  `;
  document.body.appendChild(div);
  return () => document.body.removeChild(div);
}, []);

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 font-sans overflow-hidden">
      {/* NAVBAR - identical to all other pages */}
      <header className="bg-gray-900/95 backdrop-blur-xl border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-7xl 2xl:max-w-none mx-auto px-4 sm:px-6 2xl:px-10 py-4 sm:py-5">
          <div className="flex items-center justify-between">
            
            {/* Logo + Hamburger (visible seulement mobile) */}
            <div className="flex items-center gap-4">
              <img 
                src="/bannerRank.png" 
                alt="RankMyBanner" 
                className="h-9 sm:h-10 w-auto drop-shadow-[0_0_15px_rgb(16,185,129)]" 
              />
              
              {/* Hamburger - visible < md */}
              <button 
                type="button" 
                className="md:hidden text-emerald-400 focus:outline-none"
                aria-label="Toggle menu"
                onClick={() => setIsOpen(!isOpen)}
              >
                {/* SVG hamburger ou croix selon isOpen */}
                  {isOpen ? (
                    <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  ) : (
                    <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  )}
              </button>
            </div>

            {/* Navigation */}
            <nav
                  className={`
                    ${isOpen ? 'block' : 'hidden'}              // affiche/cache sur mobile quand on clique
                    md:flex md:items-center                     // sur desktop → toujours visible + flex horizontal
                    absolute md:static top-full left-0 right-0  // position absolute sur mobile pour dropdown
                    bg-gray-900/95 md:bg-transparent            // fond sombre sur mobile, transparent sur desktop
                    border-b border-gray-800 md:border-none     // bordure basse sur mobile uniquement
                    p-6 md:p-0                                  // padding plus important sur mobile
                    flex flex-col md:flex-row                   // colonne sur mobile, ligne sur desktop
                    gap-6 md:gap-x-8 md:gap-y-0                 // espacement adapté
                    text-sm font-medium                         // style texte
                    z-40                                        // au-dessus du reste si besoin
                  `}
                >
              <a href="/" className="hover:text-emerald-400 transition hover:text-emerald-300">Home</a>
              <a href="/leaderboard" className="hover:text-emerald-400 font-semibold transition">Leaderboard</a>
              <a href="/submit" className="hover:text-emerald-400 transition">Submit Your Banner</a>
              <a href="/claim" className="text-emerald-400 transition">Claim Points</a>
              <a href="/how-to-increase" className="hover:text-emerald-400 transition">How to Increase</a>
            </nav>

            {/* Pub – cachée sur < 2xl */}
            <div className="hidden 2xl:block flex-shrink-0">
              <iframe 
                src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
                width="728" 
                height="90" 
                scrolling="no" 
                border="0" 
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      </header>

      {/* HERO */}
      <section className="relative py-28 bg-gradient-to-br from-gray-950 via-black to-gray-900 overflow-hidden">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-3 bg-emerald-500/10 border border-emerald-500/30 px-8 py-3 rounded-3xl text-emerald-400 font-medium mb-8 shadow-[0_0_30px_rgb(16,185,129,0.3)]">
            <div className="w-3 h-3 bg-emerald-400 rounded-full animate-pulse" /> 
            HOURLY BONUS
          </div>
          <h1 className="text-6xl md:text-7xl font-black tracking-[-3px] leading-none mb-8 bg-clip-text text-transparent bg-gradient-to-r from-white via-emerald-200 to-teal-300">
            CLAIM BONUS POINTS
          </h1>
          <p className="text-2xl text-gray-400 max-w-2xl mx-auto">
            Get 250–500 extra points every hour. Boost your ranking instantly.
          </p>
        </div>
      </section>

      {/* EXPLANATION */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-4xl mx-auto px-6">
          <div className="bg-gray-950 border border-gray-800 rounded-3xl p-12 text-center">
            <h2 className="text-4xl font-bold mb-8">How It Works</h2>
            <div className="grid md:grid-cols-3 gap-8 text-left">
              <div className="space-y-3">
                <div className="text-emerald-400 text-5xl">1</div>
                <p className="font-medium">Enter your banner slug</p>
              </div>
              <div className="space-y-3">
                <div className="text-emerald-400 text-5xl">2</div>
                <p className="font-medium">Complete verification</p>
              </div>
              <div className="space-y-3">
                <div className="text-emerald-400 text-5xl">3</div>
                <p className="font-medium">Get 250–500 bonus points instantly</p>
              </div>
            </div>
            <p className="text-gray-400 mt-10 max-w-2xl mx-auto">
              This system rewards active users and helps you climb the leaderboard much faster than normal visits.
            </p>
          </div>
        </div>
      </section>

      {/* CLAIM FORM */}
      <section className="py-20 bg-black">
        <div className="max-w-md mx-auto px-6">
          <div className="bg-gray-900 border border-gray-800 rounded-3xl p-10 shadow-2xl">
            <h2 className="text-3xl font-black text-center mb-8 tracking-tight">CLAIM YOUR REWARD</h2>

            <div className="space-y-8">
              {error && (
                <div className="bg-red-950 border border-red-500 text-red-400 px-6 py-4 rounded-2xl text-center">
                  {error}
                </div>
              )}

              <div>
                <label className="block text-emerald-400 font-medium mb-2 text-sm tracking-widest">YOUR BANNER SLUG</label>
                <input
                  type="text"
                  placeholder="your-banner-slug"
                  value={slug}
                  onChange={(e) => setSlug(e.target.value)}
                  className="w-full bg-gray-950 border border-gray-700 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/50 rounded-2xl px-6 py-5 text-white font-mono placeholder-gray-500 transition-all"
                />
              </div>

              <div className="flex justify-center">
                <HCaptcha
                  sitekey="dd701b24-dc2c-4252-a48c-114639bec116"
                  onVerify={token => setHcaptchaToken(token)}
                  onExpire={() => setHcaptchaToken('')}
                  theme="dark"
                />
              </div>

              <button
                onClick={handleClaim}
                disabled={loading || !hcaptchaToken}
                className="w-full py-6 bg-gradient-to-r from-emerald-500 to-teal-500 text-xl font-black rounded-3xl hover:scale-105 transition-all shadow-[0_0_40px_rgb(16,185,129)] disabled:opacity-70"
              >
                {loading ? "PROCESSING..." : "CLAIM BONUS POINTS"}
              </button>
            </div>

            {/* SUCCESS */}
            {result && (
              <div className="mt-10 text-center bg-emerald-950 border border-emerald-500/50 rounded-3xl p-10">
                <div className="text-6xl mb-4">🎉</div>
                <div className="text-emerald-400 text-4xl font-black">+{result} POINTS</div>
                <p className="text-gray-400 mt-3">Added to your banner instantly!</p>
                <a href="/leaderboard" className="inline-block mt-8 text-emerald-400 hover:text-emerald-300 font-medium">
                  → CHECK YOUR NEW RANKING
                </a>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ZeroAds bottom banner */}
      <div className="flex justify-center py-12 bg-gray-900">
        <iframe 
          src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
          width="728" height="90" scrolling="no" border="0" frameBorder="0"
        />
      </div>

      {/* FINAL CTA */}
      <div className="py-28 bg-gradient-to-r from-emerald-950 via-black to-teal-950 text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-6xl font-black tracking-tight mb-8">WANT EVEN MORE POINTS?</h2>
          <a 
            href="/submit" 
            className="inline-block px-16 py-7 text-2xl font-bold bg-white text-black rounded-3xl hover:bg-emerald-400 hover:text-black transition-all scale-105 shadow-[0_0_60px_rgb(16,185,129)]"
          >
            SUBMIT ANOTHER BANNER →
          </a>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="bg-gray-950 border-t border-gray-800 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 text-sm text-gray-500">
            <div>© 2026 RankMyBanner • All Rights Reserved</div>
            <div className="flex gap-8">
              <a href="/" className="hover:text-gray-300">Home</a>
              <a href="/leaderboard" className="hover:text-gray-300">Leaderboard</a>
              <a href="/submit" className="hover:text-gray-300">Submit Your Banner</a>
              <a href="/claim" className="hover:text-gray-300">Claim Points</a>
              <a href="/how-to-increase" className="hover:text-gray-300">How to Increase</a>
            </div>
            
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Claim;